import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import WonReasonsAPI from '../../api/wonReasons';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getWonReasons(_state) {
    return _state.records;
  },
  getActiveWonReasons(_state) {
    return _state.records
      .filter(record => record.is_active)
      .sort((a, b) => a.position - b.position);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  get: async function getWonReasons({ commit }, activeOnly = false) {
    commit(types.SET_WON_REASON_UI_FLAG, { isFetching: true });
    try {
      const response = await WonReasonsAPI.getAll(activeOnly);
      const sortedReasons = response.data.payload.sort(
        (a, b) => a.position - b.position
      );
      commit(types.SET_WON_REASONS, sortedReasons);
    } catch (error) {
      // Ignore error
    } finally {
      commit(types.SET_WON_REASON_UI_FLAG, { isFetching: false });
    }
  },
};

export const mutations = {
  [types.SET_WON_REASON_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.SET_WON_REASONS]: MutationHelpers.set,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
